import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReservationDhJson} from "../../models/reservation-dh-json.model";
import {ReservationDhJsonDashboard} from "../../models/reservationDhJsonDashboard.model";

export class DayDef {
  name: string;
  num: number;

  constructor(num: number, name: string) {
    this.name = name;
    this.num = num;
  }

}

@Component({
  selector: 'app-list-reservation-json-element',
  templateUrl: './list-reservation-json-element.component.html',
  styleUrls: ['./list-reservation-json-element.component.scss'],
})
export class ListReservationJsonElementComponent implements OnInit {

  @Input() dayHoursDashboardArray: ReservationDhJsonDashboard[];
  @Input() daysOnly: boolean = false;
  @Input() onlyHours: boolean = false;

  daysDefinitionsList: DayDef[] = [];
  numbers: number[];
  dayToEdit: ReservationDhJsonDashboard;
  @Output() editListEmitter: EventEmitter<ReservationDhJsonDashboard[]> = new EventEmitter<ReservationDhJsonDashboard[]>();
  @Output() cancelEditListEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() addedDayEmitter: EventEmitter<number> = new EventEmitter<number>();


  constructor() {
  }

  ngOnInit() {
    this.prepareDaysDefinition();
    console.log(this.dayHoursDashboardArray)
  }

  isEditMode(idx: number) {
    if (this.dayToEdit) {
      return this.dayToEdit.dayIdx === idx;
    } else {
      return false;
    }

  }

  editDay(value: ReservationDhJsonDashboard) {
    this.dayToEdit = value;
  }

  onDayCreated(obj: ReservationDhJsonDashboard) {
    this.dayHoursDashboardArray = this.dayHoursDashboardArray.map(e => {
      if (e.dayIdx === obj.dayIdx) {
        return obj;
      } else {
        return e;
      }
    });
    this.dayToEdit = null;
    this.editListEmitter.emit(this.dayHoursDashboardArray);
  }

  onCancelEdit($event: boolean) {
    this.dayToEdit = null;
  }

  translateDay(day: ReservationDhJson) {
    return this.daysDefinitionsList.filter(e => e.num === day.dayIdx).map(s => s.name)[0];
  }

  private prepareDaysDefinition() {
    this.daysDefinitionsList.push(new DayDef(1, 'Poniedziałek'));
    this.daysDefinitionsList.push(new DayDef(2, 'Wtorek'));
    this.daysDefinitionsList.push(new DayDef(3, 'Środa'));
    this.daysDefinitionsList.push(new DayDef(4, 'Czwartek'));
    this.daysDefinitionsList.push(new DayDef(5, 'Piątek'));
    this.daysDefinitionsList.push(new DayDef(6, 'Sobota'));
    this.daysDefinitionsList.push(new DayDef(7, 'Niedziela'));
  }

  emitFullDayChange() {
    this.editListEmitter.emit(this.dayHoursDashboardArray);
  }

  daysOnlyColumnOffset(index: ReservationDhJsonDashboard) {
    if (index.dayIdx === 1) return 3;
    else return 0;
  }
}
